import { render, staticRenderFns } from "./page-action-button.vue?vue&type=template&id=ac345cba&scoped=true&"
import script from "./page-action-button.vue?vue&type=script&lang=js&"
export * from "./page-action-button.vue?vue&type=script&lang=js&"
import style0 from "./page-action-button.vue?vue&type=style&index=0&id=ac345cba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac345cba",
  null
  
)

component.options.__file = "page-action-button.vue"
export default component.exports